import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import * as actions_category from "../redux/actions/adCategoryActions";
import * as actions_publish from "../redux/actions/publishActions";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import moment from "moment";
/*
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
//import Heading from "@ckeditor/ckeditor5-heading/src/heading";

const editorConfiguration = {
  plugins: [Essentials, Bold, Italic, Paragraph],
  toolbar: ["heading", "|", "bold", "italic"],
};
npm install --save \
    @ckeditor/ckeditor5-react \
    @ckeditor/ckeditor5-editor-classic \
    @ckeditor/ckeditor5-essentials \
    @ckeditor/ckeditor5-basic-styles \
    @ckeditor/ckeditor5-heading \
    @ckeditor/ckeditor5-paragraph

//plugins: [ Essentials, Paragraph, Bold, Italic, Heading ],
//toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'undo', 'redo', ]
*/
class AdCategoryItem extends React.Component {
  render() {
    return <option value={this.props.item.key}>{this.props.item.label}</option>;
  }
}

function FormField({ label, required, children, width = "full" }) {
  const widthClass =
    width === "third"
      ? "panel-edit-ad-field--third"
      : width === "half"
        ? "panel-edit-ad-field--half"
        : "";

  return (
    <div className={`panel-edit-ad-field ${widthClass}`}>
      <label className="panel-edit-ad-label">
        {required && <span className="panel-edit-ad-required">*</span>}
        {label}
      </label>
      {children}
    </div>
  );
}

class AdForm extends React.Component {
  state = {
    form: {
      price: "1.0",
      description: "",
      store_id: "",
      name: "",
    },
    touched: {
      name: false,
      categories: false,
      condition: false,
      frequency: false,
      request: false,
      expiration: false
    },
    kindComerce: "",
  };
  componentDidMount() {
    this.setState({ kindComerce: this.props.match.params.kindCommerce_id });
    this.fetchAdCategoryList();
  }

  handleBlur = (field) => (evt) => {
    this.setState({
      touched: { ...this.state.touched, [field]: true },
    });
  };

  fetchAdCategoryList = async () => {
    try {
      await this.props
        .LoadCategories(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  handleChange = (e) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeDescription = (evt, editor) => {
    this.setState({
      form: {
        ...this.state.form,
        description: editor.getData(),
      },
    });
  };

  onClickNext = async () => {
    var KindCommerceId = "0";
    switch (this.state.kindComerce) {
      case "donation":
        KindCommerceId = "1";
        break;

      case "sale":
        KindCommerceId = "2";
        break;

      case "exchange":
        KindCommerceId = "3";
        break;

      case "rent":
        KindCommerceId = "4";
        break;

      case "auction":
        KindCommerceId = "5";
        break;

      default: break;
    }
    //console.log(KindCommerceId);

    if (
      (KindCommerceId === "2" || KindCommerceId === "3") &&
      (this.errors("condition") ||
        this.errors("name") ||
        this.errors("categories"))
    ) {
      this.setState({
        ...this.state,
        touched: {
          ...this.state.touched,
          name: true,
          categories: true,
          condition: true,
        },
      });

      return;
    }

    if (
      KindCommerceId === "4" &&
      (this.errors("frequency") ||
        this.errors("name") ||
        this.errors("categories"))
    ) {
      this.setState({
        ...this.state,
        touched: {
          ...this.state.touched,
          name: true,
          categories: true,
          frequency: true,
        },
      });
      return;
    }

    if (
      KindCommerceId === "5" &&
      (this.errors("expiration") ||
        this.errors("name") ||
        this.errors("categories"))
    ) {
      this.setState({
        ...this.state,
        touched: {
          ...this.state.touched,
          name: true,
          categories: true,
          expiration: true,
        },
      });
      return;
    }

    if (
      KindCommerceId === "1" &&
      (this.errors("request") ||
        this.errors("name") ||
        this.errors("categories"))
    ) {
      this.setState({
        ...this.state,
        touched: {
          ...this.state.touched,
          request: true,
          name: true,
          categories: true,
        },
      });
      return;
    }

    let params = new FormData();

    params.append("goder_id", "");
    params.append("name", this.state.form.name);
    params.append("quantity", this.state.form.quantity || "1");
    params.append("price", this.state.form.price || "1");
    params.append("description", this.state.form.description);
    params.append("category_id", this.state.form.categories);
    params.append("kindcommerce_id", KindCommerceId);
    params.append("condition_id", this.state.form.condition);
    params.append("frequency_id", this.state.form.frequency || "");
    params.append("numRequest", this.state.form.request || "0");
    params.append("store_id", this.state.form.store_id);
    params.append("expiration", this.state.form.expiration);

    params.append("id", this.props.user_id);
    params.append("lang", I18n.t("locale"));
    try {
      await this.props.AdNew(this.props.token, params).then(() => {
        if (this.props.error_update) {
          alertify.warning(I18n.t(this.props.error_update));
        } else this.props.history.push("/goder_new_galery");
      });
    } catch (error) {
      console.log(error);
    }
  };

  errors = (field) => {
    if (
      this.state.form[field] === undefined ||
      this.state.form[field].length === 0
    ) {
      return true;
    }
    return false;
  };

  shouldMarkError = (field) => {
    const hasError = this.errors(field);
    const shouldShow = this.state.touched[field];
    return hasError ? shouldShow : false;
  };

  fieldClass = (field) =>
    this.shouldMarkError(field)
      ? "panel-edit-ad-input is-invalid"
      : "panel-edit-ad-input";

  selectClass = (field) =>
    this.shouldMarkError(field)
      ? "panel-edit-ad-select is-invalid"
      : "panel-edit-ad-select";

  render() {
    const kind = this.state.kindComerce;

    return (
      <React.Fragment>
        <div className="panel-edit-ad-form__grid">
          <FormField label={<Translate value="ad_name" />} required>
            <input
              type="text"
              id="name"
              name="name"
              data-type="product_detail"
              maxLength="100"
              className={this.fieldClass("name")}
              autoComplete="off"
              onBlur={this.handleBlur("name")}
              onChange={this.handleChange}
              value={this.state.form.name}
              required
            />
          </FormField>

          <FormField label={<Translate value="ad_quantity" />} required width="third">
            <div className="panel-edit-ad-input-group">
              <span className="panel-edit-ad-input-group__prefix">#</span>
              <input
                type="number"
                min="0"
                id="quantity"
                data-type="product"
                name="quantity"
                className="panel-edit-ad-input"
                value="1"
                onChange={this.handleChange}
                disabled
              />
            </div>
          </FormField>

          <FormField label={<Translate value="ad_price" />} required width="third">
            <div className="panel-edit-ad-input-group">
              <span className="panel-edit-ad-input-group__prefix">$</span>
              <input
                type="number"
                step="0.01"
                required
                min="0"
                id="price"
                data-type="product"
                name="price"
                className={this.fieldClass("price")}
                onBlur={this.handleBlur("price")}
                value={this.state.form.price}
                onChange={this.handleChange}
              />
            </div>
          </FormField>

          {kind === "auction" && (
            <FormField
              label={
                <>
                  <Translate value="expire" />
                  <small>{" 3 month max"}</small>
                </>
              }
              required
              width="third"
            >
              <input
                type="date"
                required
                id="expiration"
                min={moment().format("YYYY-MM-DD")}
                max={moment().add(3, "M").format("YYYY-MM-DD")}
                data-date-format="YYYY-MM-DD"
                name="expiration"
                className={this.fieldClass("expiration")}
                onBlur={this.handleBlur("expiration")}
                value={this.state.form.expiration}
                onChange={this.handleChange}
              />
            </FormField>
          )}

          {kind === "rent" ? (
            <FormField label={<Translate value="ad_frecuency" />} required width="third">
              <select
                className={this.selectClass("frequency")}
                onBlur={this.handleBlur("frequency")}
                data-type="product"
                name="frequency"
                value={this.state.form.frequency}
                onChange={this.handleChange}
                defaultValue=""
              >
                <option value="">{I18n.t("ad_select")}</option>
                <option value="H">{I18n.t("ad_hour")}</option>
                <option value="D">{I18n.t("ad_day")}</option>
                <option value="M">{I18n.t("ad_month")}</option>
                <option value="Y">{I18n.t("ad_year")}</option>
              </select>
            </FormField>
          ) : (
            kind !== "auction" && (
              <FormField label={<Translate value="ad_condition" />} required width="third">
                <select
                  className={this.selectClass("condition")}
                  onBlur={this.handleBlur("condition")}
                  data-type="product"
                  name="condition"
                  value={this.state.form.condition}
                  onChange={this.handleChange}
                  defaultValue=""
                >
                  <option value="">{I18n.t("ad_select")}</option>
                  <option value="NEW">{I18n.t("ad_new")}</option>
                  <option value="USED">{I18n.t("ad_used")}</option>
                  <option value="SERVICE">{I18n.t("ad_service")}</option>
                </select>
              </FormField>
            )
          )}

          <FormField label={<Translate value="ad_category" />} required width="half">
            <select
              className={this.selectClass("categories")}
              onBlur={this.handleBlur("categories")}
              required
              data-type="categories"
              name="categories"
              value={this.state.form.categories}
              onChange={this.handleChange}
              defaultValue={0}
            >
              <option value={0}>{I18n.t("ad_category_select")}</option>
              {this.props.adCategoryList.map((item) => (
                <AdCategoryItem item={item} key={item.key} value={item.key} />
              ))}
            </select>
          </FormField>

          {kind === "donation" ? (
            <FormField label={<Translate value="ad_request" />} required width="half">
              <div className="panel-edit-ad-input-group">
                <span className="panel-edit-ad-input-group__prefix">#</span>
                <input
                  type="number"
                  min="0"
                  id="request"
                  data-type="product"
                  name="request"
                  className={this.fieldClass("request")}
                  onBlur={this.handleBlur("request")}
                  value={this.state.form.request}
                  onChange={this.handleChange}
                />
              </div>
            </FormField>
          ) : (
            <FormField label={<Translate value="ad_marketstore" />} width="half">
              <select
                className="panel-edit-ad-select"
                data-type="product"
                name="store_id"
                value={this.props.hasStore ? this.props.store_id : "0"}
                onChange={this.handleChange}
                defaultValue="0"
              >
                {this.props.hasStore ? (
                  <option value={this.props.store_id}>{this.props.name}</option>
                ) : (
                  <option value="0">{I18n.t("ad_not_marketstore")}</option>
                )}
              </select>
            </FormField>
          )}

          <FormField label={<Translate value="ad_description" />}>
            <div className="panel-edit-ad-editor">
              <CKEditor
                data={this.state.form.description}
                editor={ClassicEditor}
                onChange={(e, editor) => this.handleChangeDescription(e, editor)}
                name="description"
              />
            </div>
          </FormField>
        </div>

        <div className="adnew-form__actions">
          <button
            type="button"
            className="panel-edit-ad-page__save"
            onClick={() => {
              this.onClickNext();
            }}
          >
            <Translate value="ad_next" />
          </button>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,

    hasStore: reducer.session.auth.hasStore,
    store_id: reducer.session.auth.store_id,
    name: reducer.session.auth.name,

    adCategoryList: reducer.adCategory.list,
    error: reducer.adCategory.error,
    loading: reducer.adCategory.loading,

    error_update: reducer.publish.error_update,
  };
}
const mapDispatchToProps = (dispatch) => ({
  LoadCategories: (user_id, token) =>
    dispatch(actions_category.loadList({ user_id, token })),
  AdNew: (token, params) => dispatch(actions_publish.newItem({ token, params })),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdForm));
/**
 *
 *
 * render() {
  let className = 'menu';
  if (this.props.isActive) {
    className += ' menu-active';
  }
  return <span className={className}>Menu</span>

   <textarea
                name="description"
                className="form-control ckeditor "
                cols="10"
                rows="5"
                value={this.state.form.description}
                onChange={this.handleChange}
              ></textarea>
} */
